<section class="migration-layout">
  <aside class="migration-layout__aside">
    <img
      [ngSrc]="'assets/images/bg-login-img.png'"
      alt="image de fond"
      class="migration-layout__aside__bg-img"
      fill="true"
      priority="true"
    />
    <div class="migration-layout__aside-content">
      <h2 class="migration-layout__aside-content__title">
        Votre facturation électronique, encore plus simple
      </h2>
      <p class="migration-layout__aside-content__description">
        Profitez d'une expérience optimisée avec des fonctionnalités enrichies,
        une navigation fluide et un accompagnement à chaque étape. Gérez vos
        factures normalisées en toute sérénité.
      </p>
      <p class="migration-layout__aside-content__footer">
        <app-copyright />
      </p>
    </div>
  </aside>
  <main class="migration-layout__main">
    <div class="migration-layout__main-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</section>
